import pick from "lodash/pick";
import type { z } from "zod";
import Textarea from "~/components/formElements/inputs/textarea/Textarea";
import type { StrapiFormComponent } from "~/services/cms/models/formElements/StrapiFormComponent";
import NumberInput from "../inputs/number/NumberInput";
import TextInput, { type InputProps } from "../inputs/text/TextInput";

export const isZodString = (
  fieldSchema: z.ZodType,
): fieldSchema is z.ZodString => fieldSchema.def.type === "string";

export const renderZodString = (
  fieldName: string,
  isFieldReadOnly: boolean,
  matchingElement?: StrapiFormComponent,
  isControlled: boolean = false,
) => {
  const sharedProps = {
    name: fieldName,
    readonly: isFieldReadOnly,
    label: !matchingElement ? fieldName : undefined, // Only use the fieldName as the label if there's no matchingElement
    ...pick(matchingElement, ["label", "placeholder", "errorMessages"]),
    controlled: isControlled,
  };

  const inputProps = {
    ...sharedProps,
    ...pick(matchingElement, ["suffix", "width", "helperText", "size"]),
  } satisfies InputProps;

  if (matchingElement?.__component === "form-elements.textarea")
    return (
      <Textarea
        key={fieldName}
        {...sharedProps}
        {...pick(matchingElement, [
          "suffix",
          "details",
          "description",
          "helperText",
          "maxLength",
        ])}
      />
    );

  const inputType =
    matchingElement && "type" in matchingElement
      ? matchingElement.type
      : "text";

  return inputType === "text" ? (
    <TextInput key={fieldName} {...inputProps} />
  ) : (
    <NumberInput key={fieldName} {...inputProps} />
  );
};
